import React from 'react'

const sprites = {
    chevsprite: {
        paths: (<g><polygon points="17.6,22.8 5.4,10.6 5.4,11 5.4,13.2 17.6,25.4 30.6,13.1 30.6,10.6 "/>
            <polygon points="269.6,13.2 257.4,25.4 257.4,25 257.4,22.8 269.6,10.6 282.6,22.9 282.6,25.4 "/>
            <polygon points="53.6,22 41.4,11.4 41.4,11.9 41.4,14.1 53.6,24.6 66.6,14 66.6,11.4 "/>
            <polygon points="233.6,14 221.4,24.6 221.4,24.1 221.4,21.9 233.6,11.4 246.6,22 246.6,24.6 "/>
            <polygon points="89.6,20.7 77.4,12.7 77.4,13.2 77.4,15.4 89.6,23.3 102.6,15.3 102.6,12.7 "/>
            <polygon points="197.6,15.3 185.4,23.3 185.4,22.8 185.4,20.6 197.6,12.7 210.6,20.7 210.6,23.3 "/>
            <polygon points="125.6,18.7 113.4,14.7 113.4,15.1 113.4,17.4 125.6,21.3 138.6,17.3 138.6,14.7 "/>
            <polygon points="161.6,17.3 149.4,21.3 149.4,20.9 149.4,18.6 161.6,14.7 174.6,18.7 174.6,21.3 "/></g>
        ),
        viewBox: '0 0 288 36',
        frames: 8,
    },
    caretx: {
        paths: (<g>
           <path d="M13.9,6.4L9,11.3L4.1,6.4H13.9 M16,5.5H2l7,7L16,5.5L16,5.5z"/>
            <polygon points="22.5,5.5 23.6,6.5 31.6,6.5 27,11.1 21.3,5.5 20,5.5 27,12.5 34,5.5 "/>
            <polygon points="106.6,2.4 104.6,2.4 99,7.9 93.5,2.5 93.4,2.4 91.4,2.4 98,9 91.4,15.6 93.4,15.6 99,10.1 104.6,15.6 106.6,15.6 
                100,9 "/>
            <polygon points="88.5,3.2 83.4,3.2 82.6,4.6 85.1,4.6 81,8.7 75.4,3.2 73.5,3.2 80,9.6 75.1,14.6 76.7,14.9 81,10.6 85.3,14.9 
                87,14.6 82,9.6 "/>
            <polygon points="70.3,4 62.3,4 62.6,5.3 67.3,5.3 63,9.6 57.4,4.1 57.4,4 55.7,4 62.1,10.5 59,13.6 58.9,13.7 60,14.3 63,11.3 
                66,14.3 66.1,14.3 67.3,13.8 63.9,10.4 "/>
            <polygon points="52.1,4.7 42.2,4.7 42.9,5.8 49.5,5.8 45,10.3 39.4,4.7 39.3,4.7 37.9,4.7 44.2,11.1 43,12.3 42.9,12.4 43.7,13.2 
                45,11.8 46.4,13.1 47.1,12.4 47.1,12.3 45.8,11 52,4.8 "/>
        </g>),
        viewBox: '0 0 108 18',
        frames: 6
    },
    ind: {
        paths: (<g>
            <rect x="6" y="7.3" width="2" height="21.7"/>
            <path d="M11.5,8.8v3.5h14.4V8.8H11.5z M24.9,11.3H12.5V9.8h12.4V11.3z"/>
            <path d="M20,25.1v1.5h-7.5v-1.5H20 M21,24.1h-9.5v3.5H21V24.1L21,24.1z"/>
            <path d="M29.5,17.4v1.5h-17v-1.5H29.5 M30.5,16.4h-19v3.5h19V16.4L30.5,16.4z"/>
            <rect x="42" y="7.3" width="2" height="21.7"/>
            <path d="M47.5,8.8v3.5h14.4V8.8H47.5z M60.9,11.3h-8.2V9.8h8.2V11.3z"/>
            <path d="M56,25.1v1.5h-7.5v-1.5H56 M57,24.1h-9.5v3.5H57V24.1L57,24.1z"/>
            <path d="M65.5,17.4v1.5H50.9v-1.5H65.5 M66.5,16.4h-19v3.5h19V16.4L66.5,16.4z"/>
            <rect x="78" y="7.3" width="2" height="21.7"/>
            <path d="M83.5,8.8v3.5h14.4V8.8H83.5z M96.9,11.3h-4.7V9.8h4.7V11.3z"/>
            <path d="M92,25.1v1.5h-6.7v-1.5H92 M93,24.1h-9.5v3.5H93V24.1L93,24.1z"/>
            <path d="M101.5,17.4v1.5H90v-1.5H101.5 M102.5,16.4h-19v3.5h19V16.4L102.5,16.4z"/>
            <rect x="114" y="7.3" width="2" height="21.7"/>
            <path d="M119.5,8.8v3.5h14.4V8.8H119.5z M132.9,11.3h-2.1V9.8h2.1V11.3z"/>
            <path d="M128,25.1v1.5h-5.5v-1.5H128 M129,24.1h-9.5v3.5h9.5V24.1L129,24.1z"/>
            <path d="M137.5,17.4v1.5H128v-1.5H137.5 M138.5,16.4h-19v3.5h19V16.4L138.5,16.4z"/>
            <rect x="150" y="7.3" width="2" height="21.7"/>
            <path d="M155.5,8.8v3.5h14.4V8.8H155.5z"/>
            <path d="M164,25.1v1.5h-4.7v-1.5H164 M165,24.1h-9.5v3.5h9.5V24.1L165,24.1z"/>
            <path d="M173.5,17.4v1.5h-7.2v-1.5H173.5 M174.5,16.4h-19v3.5h19V16.4L174.5,16.4z"/>
            <rect x="186" y="7.3" width="2" height="21.7"/>
            <path d="M191.5,8.8v3.5h14.4V8.8H191.5z"/>
            <path d="M200,25.1v1.5h-3.8v-1.5H200 M201,24.1h-9.5v3.5h9.5V24.1L201,24.1z"/>
            <path d="M209.5,17.4v1.5h-2.9v-1.5H209.5 M210.5,16.4h-19v3.5h19V16.4L210.5,16.4z"/>
            <rect x="222" y="7.3" width="2" height="21.7"/>
            <path d="M227.5,8.8v3.5h14.4V8.8H227.5z"/>
            <path d="M236,25.1v1.5h-2.3v-1.5H236 M237,24.1h-9.5v3.5h9.5V24.1L237,24.1z"/>
            <path d="M245.5,17.4v1.5H244v-1.5H245.5 M246.5,16.4h-19v3.5h19V16.4L246.5,16.4z"/>
            <rect x="258" y="7.3" width="2" height="21.7"/>
            <path d="M263.5,8.8v3.5h14.4V8.8H263.5z"/>
            <path d="M272,25.1v1.5h-0.9v-1.5H272 M273,24.1h-9.5v3.5h9.5V24.1L273,24.1z"/>
            <path d="M282.5,16.4h-19v3.5h19V16.4L282.5,16.4z"/>
            <rect x="294" y="7.3" width="2" height="21.7"/>
            <path d="M299.5,8.8v3.5h14.4V8.8H299.5z"/>
            <path d="M309,24.1h-9.5v3.5h9.5V24.1L309,24.1z"/>
            <path d="M318.5,16.4h-19v3.5h19V16.4L318.5,16.4z"/>
        </g>),
        viewBox: '0 0 324 36',
        frames: 9
    },
    county: {
        paths: (<g>
<path d="M16,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,12.5,16,12.5z M16,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1
        s1-0.5,1-1S16.5,9.5,16,9.5z"/>

    <path d="M16,20.8l-0.4-0.5C15.4,20,10,13.6,10,10.5c0-3.3,2.7-6,6-6s6,2.7,6,6c0,3.1-5.4,9.6-5.6,9.8L16,20.8z M16,5.5
        c-2.8,0-5,2.2-5,5c0,2.1,3.3,6.6,5,8.7c1.7-2.1,5-6.6,5-8.7C21,7.7,18.8,5.5,16,5.5z"/>

    <polygon points="23.6,19 20.3,19 19.5,20 23.2,20 27.4,25 4.6,25 8.6,20 12.7,20 11.9,19 8.2,19 2.5,26 29.5,26    "/>

    <polygon points="55.6,19 52.3,19 51.5,20 55.2,20 59.4,25 36.6,25 40.6,20 44.7,20 43.9,19 40.2,19 34.5,26 61.5,26    
        "/>

    <polygon points="87.6,19 84.3,19 83.5,20 87.2,20 91.4,25 68.6,25 72.6,20 76.7,20 75.9,19 72.2,19 66.5,26 93.5,26    
        "/>

    <polygon points="119.6,19 116.3,19 115.5,20 119.2,20 123.4,25 100.6,25 104.6,20 108.7,20 107.9,19 104.2,19 98.5,26 
        125.5,26    "/>

    <polygon points="151.6,19 148.3,19 147.5,20 151.2,20 155.4,25 132.6,25 136.6,20 140.7,20 139.9,19 136.2,19 
        130.5,26 157.5,26   "/>

    <polygon points="183.6,19 180.3,19 179.5,20 183.2,20 187.4,25 164.6,25 168.6,20 172.7,20 171.9,19 168.2,19 
        162.5,26 189.5,26   "/>

    <polygon points="215.6,19 212.3,19 211.5,20 215.2,20 219.4,25 196.6,25 200.6,20 204.7,20 203.9,19 200.2,19 
        194.5,26 221.5,26   "/>

    <polygon points="247.6,19 244.3,19 243.5,20 247.2,20 251.4,25 228.6,25 232.6,20 236.7,20 235.9,19 232.2,19 
        226.5,26 253.5,26   "/>

    <path d="M48,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S49.1,12.5,48,12.5z M48,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1
        s1-0.5,1-1S48.5,9.5,48,9.5z"/>
<path d="M48,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C54,7.2,51.3,4.5,48,4.5z M48,5.5c2.8,0,5,2.2,5,5c0,1.6-2,4.7-3.6,7h-2.7c-1.7-2.3-3.7-5.4-3.7-7C43,7.7,45.2,5.5,48,5.5z"/>

    <path d="M80,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S81.1,12.5,80,12.5z M80,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1
        s1-0.5,1-1S80.5,9.5,80,9.5z"/>
<path d="M80,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C86,7.2,83.3,4.5,80,4.5z M80,5.5c2.8,0,5,2.2,5,5c0,1.1-0.9,2.9-2,4.6h-6c-1.1-1.7-2-3.5-2-4.6C75,7.7,77.2,5.5,80,5.5z"/>

    <path d="M112,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S113.1,12.5,112,12.5z M112,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1
        s1-0.5,1-1S112.5,9.5,112,9.5z"/>
<path d="M112,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C118,7.2,115.3,4.5,112,4.5z M112,5.5c2.8,0,5,2.2,5,5c0,0.7-0.3,1.5-0.8,2.5h-8.4c-0.5-1-0.8-1.8-0.8-2.5
    C107,7.7,109.2,5.5,112,5.5z"/>
<path d="M176,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C182,7.2,179.3,4.5,176,4.5z M176,5.5c1.9,0,3.5,1.1,4.4,2.7h-8.8C172.5,6.6,174.1,5.5,176,5.5z M176,11.6c-0.6,0-1.2-0.6-1.2-1.2
    s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S176.6,11.6,176,11.6z"/>
<path d="M208,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C214,7.2,211.3,4.5,208,4.5z M211.3,6.8h-6.7c0.9-0.8,2.1-1.3,3.3-1.3S210.5,6,211.3,6.8z M208,12.2c-0.9,0-1.7-0.8-1.7-1.7
    s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S208.9,12.2,208,12.2z"/>
<path d="M240,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C246,7.2,243.3,4.5,240,4.5z M240,12.5c-1,0-2-1-2-2s1-2,2-2s2,1,2,2S241,12.5,240,12.5z"/>
<path d="M144,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8
    C150,7.2,147.3,4.5,144,4.5z M144,11.4c-0.5,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S144.5,11.4,144,11.4z M144,8.4c-1.1,0-2,0.9-2,2h-3
    c0.1-2.7,2.3-4.9,5-4.9s4.9,2.2,5,4.9h-3C146,9.3,145.1,8.4,144,8.4z"/>
        </g>),
        viewBox: '0 0 256 32',
        frames: 8
    },
    book: {
        paths:(<g>
            <path d="M16,8.3c-1.1-1.1-4.6-3.4-13.5-3.4H2v15h0.5c10.6-0.1,13,3.4,13.1,3.5L16,24l0.5-0.7c0,0,2.5-3.6,13.1-3.6H30
    V4.9h-0.5C20.6,4.9,17.1,7.2,16,8.3z M15.5,21.7c-1.5-1.2-5-3-12.4-3V5.9C12.2,6,15,8.7,15.5,9.3V21.7z M29,18.7
    c-7.4,0.1-10.9,1.9-12.4,3.1V9.3C17,8.7,19.8,6,29,5.9V18.7z"/>
<path d="M47.6,23.3l0.4,0.6l0.5-0.5c0,0,4.4-5,11.3-6.1l0.4-0.1V2.3l-0.6,0.1C52.4,3.7,49.1,7,48,8.3
    c-1.1-1.1-4.6-3.4-13.5-3.4H34v15h0.5C45.1,19.7,47.5,23.3,47.6,23.3z M48.5,9.3C49.1,8.6,52,5,59.1,3.5v12.7
    c-5.2,1-8.9,3.9-10.5,5.5L48.5,9.3L48.5,9.3z M48.1,22.1L48,22.2l-0.1-0.1H48.1z M35,5.9C44.1,6,47,8.7,47.5,9.3v12.5
    c-1.5-1.2-5-3-12.4-3L35,5.9L35,5.9z"/>
<path d="M79.6,23.3l0.5,0.9l0.4-0.9c0,0,2.1-4.9,9-6.7l0.4-0.1v-15l-0.7,0.2c-5.8,1.6-8.5,5.1-9.4,6.6
    C78.7,7.2,75.1,5,66.5,5H66v15h0.5C77,19.7,79.5,23.2,79.6,23.3z M80.5,9.3c0.3-0.6,2.5-4.6,8.3-6.4v12.7c-4.6,1.3-7.1,3.8-8.3,5.5
    V9.3z M67,18.9V6c9.1,0.1,12,2.8,12.4,3.4v12.4c-1.5-1.1-4.9-2.9-12.1-2.9C67.2,18.9,67.1,18.9,67,18.9z"/>
<path d="M61,18.7c-0.4,0-3.6,0.4-6.7,1.7c2.1-0.5,4.5-0.7,7.2-0.7H62V4.9h-1V18.7z"/>
<path d="M336,8.3c-1.1-1.3-4.5-4.6-11.5-5.9l-0.6-0.1v14.9l0.4,0.1c6.9,1.2,11.2,6.1,11.3,6.1l0.5,0.5l0.4-0.6
    c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C340.7,4.9,337.2,7.2,336,8.3z M335.5,21.7c-1.6-1.5-5.3-4.5-10.5-5.5V3.5c7,1.5,10,5,10.5,5.7
    V21.7z M336,22.2l-0.1-0.1h0.2L336,22.2z M349,18.8c-7.4,0-10.9,1.8-12.4,3V9.3C337.1,8.7,340,6,349,5.9V18.8z"/>
<path d="M323,18.7V4.9h-1v14.8h0.5c2.7,0,5.1,0.2,7.2,0.7C326.6,19.1,323.4,18.7,323,18.7z"/>
<path d="M91.5,5v1c0.1,0,0.8-0.1,1.5-0.1v12.7c-7.4,0.4-9.7,2.7-9.7,2.7c2-0.9,5.2-1.7,10.3-1.7H94V4.9h-0.5
    C92.6,4.9,91.8,4.9,91.5,5z"/>
<path d="M304.1,8.3c-0.9-1.5-3.5-5-9.4-6.6L294,1.5v14.9l0.4,0.1c6.9,1.8,9,6.6,9,6.7l0.4,0.9l0.5-0.8
    c0,0,2.5-3.5,13-3.4h0.5V5h-0.5C308.9,5,305.3,7.2,304.1,8.3z M303.5,21.1c-1.2-1.7-3.8-4.2-8.3-5.5V2.9c5.8,1.9,8,5.8,8.3,6.4V21.1
    z M317,18.9c-0.1,0-0.2,0-0.3,0c-7.2,0-10.7,1.7-12.1,2.9V9.4c0.5-0.6,3.3-3.3,12.4-3.4V18.9z"/>
<path d="M291,18.6V5.9c0.7,0,1.4,0.1,1.5,0.1V5c-0.3-0.1-1.1-0.1-2-0.1H290v14.7h0.4c5.1,0,8.3,0.8,10.3,1.7
    C300.7,21.3,298.4,19,291,18.6z"/>
<path d="M111.6,23.3l0.6,1l0.3-1.1c0-0.1,1.7-5.2,6.5-7.1l0.3-0.1V1l-0.7,0.3c-4.1,1.8-6,5.3-6.8,6.8
    C110.5,7,107,4.9,98.5,4.9H98v15h0.5C109,19.7,111.5,23.2,111.6,23.3z M112.5,9.2c0.2-0.6,1.8-4.4,5.7-6.5v12.6
    c-3,1.3-4.7,3.6-5.7,5.3V9.2z M99,5.9c9.2,0.1,12,2.8,12.4,3.4v12.5c-1.5-1.2-5-3-12.4-3V5.9z"/>
<path d="M143.6,23.3l0.6,1l0.3-1.2c0,0,1.3-4.7,4.1-6.9l0.2-0.2V0.9L148,1.6c-2.4,2-3.7,5-4.2,6.5
    c-1.3-1.1-4.9-3.2-13.3-3.2H130v15h0.5C141,19.7,143.5,23.2,143.6,23.3z M144.5,9.2c0.1-0.5,1.1-3.6,3.2-5.9v12.3
    c-1.5,1.3-2.5,3.1-3.2,4.6V9.2z M131,5.9c9.2,0.1,12,2.8,12.4,3.4v12.5c-1.5-1.2-5-3-12.4-3V5.9z"/>
<path d="M150.2,5.6v1.1c1.7-0.4,3.9-0.7,6.7-0.7v12.7c-4.6,0.1-7.7,0.8-9.7,1.6c-0.3,0.4-0.6,0.9-0.8,1.5
    c1.8-1,5.2-2,11.1-2h0.5V4.9h-0.5C154.5,4.9,152.1,5.2,150.2,5.6z"/>
<path d="M240.2,8.1c-0.5-1.5-1.8-4.5-4.2-6.5l-0.9-0.7v15.2l0.2,0.2c2.8,2.3,4.1,6.9,4.1,6.9l0.3,1.1l0.6-1
    c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C245.1,4.9,241.6,7,240.2,8.1z M239.5,20.1c-0.7-1.5-1.7-3.3-3.2-4.6V3.2
    c2.1,2.3,3.1,5.5,3.2,5.9V20.1z M253,18.8c-7.4,0-10.9,1.8-12.4,3V9.3c0.5-0.6,3.3-3.3,12.4-3.4V18.8z"/>
<path d="M236.8,20.3c-2-0.8-5.1-1.5-9.7-1.6V6c2.8,0,5,0.3,6.7,0.7V5.6c-1.9-0.4-4.3-0.7-7.3-0.7H226v14.9h0.5
    c5.9,0,9.3,1,11.1,2C237.4,21.2,237.1,20.7,236.8,20.3z"/>
<path d="M175.6,23.3l0.6,0.9l2.8-7.8v-17l-3.1,8.7c-1.3-1.1-4.9-3.2-13.3-3.2h-0.5v15h0.5
    C173,19.7,175.5,23.2,175.6,23.3z M176.5,9.2l1.3-3.7v10.7l-1.3,3.8V9.2z M163,5.9c9.2,0.1,12,2.8,12.4,3.4v12.5
    c-1.5-1.2-5-3-12.4-3V5.9z"/>
<path d="M124.7,4.9c-1.3,0-2.5,0.1-3.6,0.2v1.1c0.8-0.1,1.6-0.2,2.5-0.2c0.1,0,0.4,0,0.7-0.1c0.2,0,0.5,0,0.7,0v10.9
    v1.9c-7.4,0.4-9.7,2.7-9.7,2.7c2-0.9,5.2-1.7,10.3-1.7h0.5v-2.9V4.9h-0.5C125.3,4.9,125,4.9,124.7,4.9z"/>
<path d="M272.2,8.1c-0.7-1.5-2.7-5-6.8-6.8L264.7,1v15l0.3,0.1c4.8,1.9,6.5,7,6.5,7.1l0.3,1l0.6-0.9
    c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C277,4.9,273.5,7,272.2,8.1z M271.5,20.6c-1-1.7-2.8-4.1-5.7-5.3V2.7c3.9,2.1,5.5,6,5.7,6.5V20.6
    z M285,18.8c-7.5,0-11,1.8-12.4,3V9.3c0.5-0.6,3.3-3.3,12.4-3.4V18.8z"/>
<path d="M259,18.7v-1.9V5.9c0.2,0,0.5,0,0.7,0C260,6,260.3,6,260.4,6c0.9,0,1.7,0.1,2.5,0.2V5.1
    c-1.1-0.1-2.3-0.2-3.6-0.2c-0.3,0-0.6,0-0.9,0h-0.5v11.9v2.9h0.5c5.1,0,8.3,0.8,10.3,1.7C268.7,21.4,266.4,19.1,259,18.7z"/>
<path d="M180.6,6v1.1c1.9-0.6,4.6-1.1,8.3-1.1v12.7c-4.6,0.1-7.7,0.8-9.7,1.6l-0.6,1.5c2-0.9,5.7-2,10.8-2h0.5V4.9h-0.5
    C185.6,4.9,182.7,5.4,180.6,6z"/>
<path d="M208.2,8.1l-3.1-8.7v16.8l2.8,7.9l0.6-0.9c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C213.1,4.9,209.5,7,208.2,8.1z
     M207.5,19.9l-1.3-3.8V5.5l1.3,3.7V19.9z M221,18.8c-7.4,0-11,1.8-12.4,3V9.3c0.5-0.6,3.3-3.3,12.4-3.4V18.8z"/>
<path d="M204.8,20.3c-2-0.8-5.1-1.5-9.7-1.6V6c3.7,0,6.4,0.5,8.3,1.1V6c-2.1-0.6-4.9-1.1-8.8-1.1h-0.5v14.9h0.5
    c5.1,0,8.9,1.2,10.8,2L204.8,20.3z"/>


</g>),
        viewBox: '0 0 352 32',
        frames: 11 
    },
    underbook: {
        paths: (<g>
<path d="M77.7,27.6c0,0.3,0.1,0.5,0.1,0.8H82c0.1-0.2,0.1-0.5,0.1-0.8c0-0.3-0.1-0.6-0.2-0.8v0.1h-4v-0.3
    C77.8,26.8,77.7,27.2,77.7,27.6z"/>
<path d="M114.7,27.6c0-0.7-0.3-1.4-0.7-1.9v1.1h-4v-1.2c-0.5,0.5-0.9,1.2-0.9,2c0,0.3,0.1,0.5,0.1,0.8h5.4
    C114.7,28.1,114.7,27.9,114.7,27.6z"/>
<path d="M147.6,28.4v-1.6l1.2-0.2c-0.1-0.5-0.3-1-0.6-1.5l-2.1,0.4v1.4h-4v-1.4l-2.1-0.4c-0.3,0.4-0.5,0.9-0.6,1.5
    l1.2,0.2v1.6H147.6z"/>
<path d="M46.8,28.4h2.2c0.2-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.3-0.8h-2.2c-0.2,0.2-0.3,0.5-0.3,0.8
    C46.6,27.9,46.7,28.2,46.8,28.4z"/>
<path d="M179.6,28.4v-1.6l3.8-0.8c-0.1-0.5-0.3-1-0.5-1.5l-4.9,1v1.4h-4v-1.4l-4.9-1c-0.2,0.5-0.4,1-0.5,1.5l3.8,0.8
    v1.6H179.6z"/>
<path d="M211.6,28.4v-1.6l5.9-1.3c-0.1-0.5-0.3-1-0.5-1.5l-7,1.5v1.4h-4v-1.4l-7-1.5c-0.2,0.5-0.3,1-0.5,1.5l5.9,1.3
    v1.6H211.6z"/>
<path d="M243.6,28.4v-1.6l7.7-1.6c-0.1-0.5-0.3-1-0.4-1.5l-8.8,1.9v1.4h-4v-1.4l-8.8-1.9c-0.2,0.5-0.3,1-0.4,1.5
    l7.7,1.6v1.6H243.6z"/>
<polygon points="274,25.5 274,26.8 270,26.8 270,25.5 259.3,23.2 259.3,24.8 268.4,26.7 268.4,28.4 275.6,28.4 
    275.6,26.7 284.7,24.8 284.7,23.2 "/>
        </g>),
        viewBox: '0 0 288 32',
        frames: 9
    }

}

export default sprites


// WEBPACK FOOTER //
// ./src/components/generic/spritemanifest.js